import baseViewSelector from './quiz_base_view_selector'
import validationSelector from './quiz_validation_selector'
import saveSelector from './quiz_save_selector'
import deleteQuestionValidationSelector from './quiz_delete_question_validation_selector'
import deleteAnswerValidationSelector from './quiz_delete_answer_validation_selector'
import questionSelector from './quiz_question_selector'
import questionServerSelector from './quiz_question_server_selector'
import dropQuestionSelector from './quiz_drop_question_selector'
import addQuestionValidationSelector from './quiz_add_question_validation_selector'
import addAnswerValidationSelector from './quiz_add_answer_validation_selector'
import quizCancelSelector from './quiz_cancel_selector'
import questionsChangedSelector from './quiz_questions_changed_selector'

export default {
	baseViewSelector,
	validationSelector,
	saveSelector,
	deleteQuestionValidationSelector,
	deleteAnswerValidationSelector,
	questionSelector,
	questionServerSelector,
	dropQuestionSelector,
	addQuestionValidationSelector,
	addAnswerValidationSelector,
	quizCancelSelector,
	questionsChangedSelector,
}
